import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import { StyledContainer } from './Layout.styled';
import { Outlet } from 'react-router-dom';

export default function Layout() {
  return (
    <StyledContainer>
      <Header />
      <Outlet />
      <Footer />
    </StyledContainer>
  );
}
